import React, { useState, useEffect, useRef } from "react";

import { Box, TextField, IconButton, Button, Tooltip } from "@mui/material";

import SendIcon from '@mui/icons-material/Send';

import useNotification from '../Notification';
import api from '../../api';

import { getSession } from "../../auth";
import Loading from '../Loading'
import dayjs from 'dayjs'
import { transformTimeData } from "../Scout/Pages/ChatList";

import './index.css'
import { ShowComponent } from "../../utils/isVisible";

let gluedOnBottom = true

const loadAndScroll = async (callback, scrollRef) => {
    const previousScrollHeight = scrollRef.current?.scrollHeight || 0
    await callback()
    const nextScrollHeight = scrollRef.current?.scrollHeight || 0
    if (previousScrollHeight && nextScrollHeight && scrollRef) {
        scrollRef.current.scrollBy(0, Math.abs(nextScrollHeight - previousScrollHeight))
    }
}

const onScroll = (event) => {
    if ((event.target.scrollHeight - Math.round(event.target.scrollTop)) <= event.target.offsetHeight + 1) {
        gluedOnBottom = true
        return
    }
    if (gluedOnBottom)
        gluedOnBottom = false
}

const scrollToBottom = (scrollRef) => {
    if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
};


const InternalChat = ({ reAnchor, socket, channel, messages, teamId, loadMore, finished }) => {

    const user = getSession()

    const scrollRef = useRef(null);

    const [message, setMessage] = useState('')
    const [ready, setReady] = useState(false)

    const list_messages = Object.values(messages)

    const sendMessage = async () => {
        if (message && socket) {
            const payload = {
                'channel' : channel,
                'message' : message,
                'user'    : `${user.first_name} ${user.last_name}`,
                'team'    : teamId  
            }

            const enterpriseId = getSession().profile.enterprise.id
            const res = await api.post(`/api/enterprises/${enterpriseId}/chat_messages/`, payload)
            
            if (res.status !== 201) {
                useNotification(
                    'Ops!',
                    'Algo deu errado, tente novamente.',
                    'danger'
                )
                return
            }

            payload.id = res.data.id

            socket.send(JSON.stringify(payload))
            setMessage('')
            scrollToBottom(scrollRef);
        }
    }


    useEffect(() => {
        if ((list_messages.length > 0 && !ready) || gluedOnBottom){
            scrollToBottom(scrollRef);
            setReady(true)
        }
    }, [list_messages, ready]);

    return (
        <Box className="internal-chat-container">
            {/* <Loading loading={!ready} nofixed/> */}
            <Box className={`internal-chat-chat ${ready ? '': 'hidden'}`}>
                <ul ref={scrollRef} onScroll={onScroll}>
                    {(!finished && ready) &&
                    <ShowComponent 
                        parent={scrollRef}
                        loading={!ready}
                        isVisibleHook={(e) => {if (e && ready && !gluedOnBottom) loadAndScroll(loadMore, scrollRef) }}
                    ></ShowComponent>
                        }
                    {list_messages.map((each) => (
                        <Box
                        key={`internal-chat-individual-message-${teamId}-${each.id}`}
                        className={each.user === `${user.first_name} ${user.last_name}` ? "message-right" : "message-left"}>
                            <Box className={each.user === `${user.first_name} ${user.last_name}` ? "message-item right" : "message-item left"}>
                                <Box>{each.user}:</Box>
                                <Box>{each.message}</Box>
                                <Tooltip title={dayjs.unix(each.timestamp).format('DD/MM/YYYY HH:mm')}><Box>{transformTimeData(each.timestamp)}</Box></Tooltip>
                            </Box>
                        </Box>
                    ))}
                </ul>
            </Box>
            <Box className="internal-chat-footer">
                <TextField
                    className="internal-chat-input"
                    size="small"
                    fullWidth
                    type="text"
                    variant="outlined"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyPress={(e) => { if (e.key == 'Enter') sendMessage() }}
                    placeholder="Digite sua mensagem..."
                />
                <IconButton onClick={sendMessage}>
                    <SendIcon />
                </IconButton>
            </Box>
        </Box>
    );
}

export default InternalChat;
